import { render, staticRenderFns } from "./Duplica.vue?vue&type=template&id=b651848e&"
import script from "./Duplica.vue?vue&type=script&lang=js&"
export * from "./Duplica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports